export const white = '#FFFFFF';

export const grey = {
  50: '#FAFAFA',
  100: '#F5F5F5',
  200: '#EEEEEE',
  300: '#E0E0E0',
  400: '#BDBDBD',
  500: '#9E9E9E',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121'
};

export const black = '#000000';
export const blue = '#0C1956';
export const green = '#17A728';
export const orange = '#FA861E';
export const red = '#ED4740';
export const cyan = "#007AFF";
export const yellow = "#FFF200";
export const purple = "#A237F3";
export const primary = {
  main: blue,
  light: '#F6F9FD',
  dark: '#0B48A0'
};

export const _black = '#131415';